import { render, staticRenderFns } from "./PopularTag.vue?vue&type=template&id=775d019e&scoped=true"
import script from "./PopularTag.vue?vue&type=script&lang=js"
export * from "./PopularTag.vue?vue&type=script&lang=js"
import style0 from "./PopularTag.vue?vue&type=style&index=0&id=775d019e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d019e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775d019e')) {
      api.createRecord('775d019e', component.options)
    } else {
      api.reload('775d019e', component.options)
    }
    module.hot.accept("./PopularTag.vue?vue&type=template&id=775d019e&scoped=true", function () {
      api.rerender('775d019e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/PopularTag.vue"
export default component.exports